import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/movementV2/pageContext';

export const MovementV2ErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	/** Possible to implement custom view based on error instead of throwing */
	throw new Error(`Failed to retrieve data for MovementV2 page (error: ${error})`);
};
